import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../utils/mediaQueriesTemplate";
import { defaultTheme } from "../../../../theme/theme";


export const ActionsWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 1px;
  display: flex;

  ${mediaMinWidth.tablet`
    right: 10px;
  `}
`;

export const Messages = styled.div`
  margin: 4px 10px;
  font-size: 2.3em;
  cursor: pointer;
  position: relative;

  ${mediaMaxWidth.tablet`
    display: none;
  `}
`;

export const MessagesLink = styled.a`
  color: ${defaultTheme.colors.mainPurpleColor}!important;
`;

export const Counter = styled.span`
  font-size: 0.35em;
  top: 3px;
  padding: 0 5px;
  right: 0;
  font-family: sans-serif;
  background-color: #79D9D9;
  border-radius: 16px;
  position: absolute;
  letter-spacing: 0.05em;
  font-weight: 700;
  margin-left: 5px;
  color: #fff;
  -webkit-text-stroke: 0px;
`;

export const AccountMenuWrapper = styled.div`
  margin: 5px 0;
  color: #333;
  border: 1px solid #fff;
  padding: 7px 7px 1px 7px;
  border-bottom: none;
  background: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: 0.1s ease-in-out;
  position: relative;
  height: 50px;
  top: -1px;
  width: 60px;

  &.active {
    border: 1px solid #bdbdbd;
    border-bottom: none;
    height: 52px;
  }

  &:hover {
    cursor: pointer;
  }

  ${mediaMaxWidth.tablet`
    right: 5px;
    top: -2px;
  `}
`;

export const Avatar = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 3px;
`;

export const Menu = styled.div`
  position: absolute;
  right: -1px;
  top: 50px;
  background-color: #fff;
  border: 1px solid #bdbdbd;
  width: 220px;
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 2px 4px 8px rgba(160, 160, 160, 0.35);
  padding: 10px;
  opacity: 0;
  visibility: hidden;
  transition: 0.1s ease-in-out;
  z-index: -1;
  &.active {
    opacity: 1;
    visibility: visible;
  }
`;

export const ItemsWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const UserName = styled.div`
  text-align: center;
  padding-top: 5px;
  font-size: 0.95em;
  letter-spacing: 0.3px;
`;

export const CompanyName = styled.div`
  text-align: center;
  font-size: 0.75em;
  margin-bottom: 20px;
  font-weight: 700;
  letter-spacing: 0.2px;
`;

export const Link = styled.a`
  color: #333 !important;
  padding: 5px 15px 5px 8px;
  border-radius: 4px;
  margin: 3px 0;
  font-size: 0.9em;
  display: flex;
  transition: 0.1s ease-in-out;

  &:hover {
    background-color: #79D9D9;
    color: #fff !important;
  }

  &#switch-account-link {
    color: #27ae60 !important;
    font-weight: 700;

    &:hover {
      color: #fff !important;
    }
  }

  &.logout-link {
    margin-top: 20px;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  width: 40px;
`;

export const LinkLabel = styled.div`
  display: flex;
  flex: 1;
`;
